import script from "./sdsConsolePanel.vue?vue&type=script&lang=js"
export * from "./sdsConsolePanel.vue?vue&type=script&lang=js"

import "./sdsConsolePanel.vue?vue&type=style&index=0&id=cb11b986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb11b986"]])

export default __exports__